import React, { useEffect } from 'react'
import Flex from 'typescript-styled-flex'
import { INumberInputProps } from './NumberInput'
import WrappingText from './WrappingText'

type C = React.ComponentType<INumberInputProps>

function withRedux(Component: C) {
  return function ({
    wrapWithTextAfter,
    wrapWithTextBefore,
    size = 1,
    wrapperFull,
    wraping = true,
    wrapperSpace = false,
    justifyCenter = true,
    ...rest
  }: INumberInputProps) {
    const [wrap, toggleWrap] = React.useState(
      wraping && !(window.innerWidth > 376),
    )

    if (
      ('' === wrapWithTextBefore || wrapWithTextBefore === undefined) &&
      ('' === wrapWithTextAfter || wrapWithTextAfter === undefined)
    ) {
      return <Component size={size} {...rest} />
    }

    useEffect(() => {
      function shouldWrap() {
        window.innerWidth > 376 ? toggleWrap(false) : toggleWrap(true)
      }

      if (wraping) {
        window.addEventListener('resize', shouldWrap)
      }

      return function cleanup() {
        window.removeEventListener('resize', shouldWrap)
      }
    })

    return (
      <Flex
        row={!wrap}
        column={wrap}
        alignCenter={!wrap}
        justifyCenter={justifyCenter}
        style={{ width: '100%' }}
      >
        <Flex
          row={true}
          alignCenter={wrap}
          justifyStart={wrap}
          full={wrapperFull}
        >
          {wrapWithTextBefore && (
            <Flex
              justifyEnd={!wrap}
              alignCenter={!wrap}
              style={
                wrapperSpace
                  ? wrapperSpace
                  : {
                      marginRight: `${0.7 * size}em`,
                      minWidth: `${4 * size}em`,
                      width: `${4 * size}em`,
                    }
              }
            >
              <WrappingText
                size={size}
                style={{ textAlign: wrap ? 'unset' : 'end' }}
              >
                {wrapWithTextBefore}
              </WrappingText>
            </Flex>
          )}
          <Component size={size} {...rest} />
        </Flex>
        {wrapWithTextAfter && (
          <WrappingText
            size={size}
            style={{
              marginLeft: wrap ? '' : `${0.7 * size}em`,
              marginTop: wrap ? `${0.7 * size}em` : '',
              textAlign: wrap ? 'start' : 'unset',
            }}
          >
            {wrapWithTextAfter}
          </WrappingText>
        )}
      </Flex>
    )
  }
}

export default withRedux
